export const validateName = async (rule,value) => {
    if(value && value.length < 2){
        throw new Error('Debe tener al menos 2 caracteres de longitud');
    }
    // eslint-disable-next-line
    if(value && !(/^[a-zA-Z0-9ñáéíóúÁÉÍÓÚ\s\.\,\-\_]+$/g.test(value))){
        throw new Error(`Caracteres permitidos : Alfanumericos, espacios, punto,coma y guiones`);
    }
}

export const validatePhone = async (rule,value) => {
    if(value && !(/^[0-9]{1}[0-9]{7}$/.test(value) || /^[0-9]{2}[0-9]{6}$/.test(value) || /^[0-9]{9}$/.test(value))){
        throw new Error('Debe ser un telefono valido');
    }
}